import { BankAccountDto, BankAccountModel } from '../types/bank-account'

const transformBankAccount = ({
  name,
  account_number,
  is_default,
}: BankAccountDto): BankAccountModel => ({
  name,
  accountNumber: account_number,
  isDefault: !!is_default,
})

export const transformBankAccounts = (
  bankAccounts: Array<BankAccountDto>,
): Array<BankAccountModel> => bankAccounts.map(transformBankAccount)
